export default __webpack_public_path__ + "static/media/blog.f5bf8918.png";